export interface Settings {
    maxDayAfter?: number
    maxDayBefore?: number
}

export const MinValidDate = new Date(2000, 1, 1)
